module.exports = __webpack_public_path__ + "img/h_s1e1_interactions_2.5c5ecb6a.png";